<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="services_image">
                    <img 
                    :src="servicio.servicio_imagen" alt="image" />
                    <div class="service_heading white-text">
                        <h3>{{ servicio.texto_imagen }}</h3>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center ">
                        <div class="form-group">
                            <!--<button class="btn" type="submit">
                                Comprar Plan de Comercialización
                                <span class="angle_arrow"
                                    ><i
                                        class="fa fa-angle-right"
                                        aria-hidden="true"
                                    ></i
                                ></span>
                            </button>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h3>
                    {{ servicio.titulo }}
                </h3>
                <div v-html="servicio.servicio_description"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        servicio: Object
    }
};
</script>

<style lang="scss" scoped></style>
